import Node from '~/scripts/services/model/node';
import templateModalAdminOoCreateClass from './modal/modal-admin-oo-create-class.html';
import ModalAdminOoCreateClassController from './modal/modal-admin-oo-create-class.controller';

export default class AdminOoController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').route.IRouteParamsService} $routeParams
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} NodeService
	 * @param {any} Notification
	 * @param {any} User
	 */
	constructor(
		$location,
		$rootScope,
		$routeParams,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		NodeService,
		Notification,
		User,
	) {
		this.currentKid = undefined;
		this.display = !!$routeParams.kid;

		/** @type {?import('angular').IFormController} */
		this.form = null;

		/** @type {?Node} */
		this.node = null;

		/** @type {any} */
		this.oldNode = undefined;

		/** @type {any} */
		this.options = {
			delete:        true,
			headerButtons: true,
			root:          true,
		};

		/** @type {string} */
		this.tab = $routeParams.tab || 'info';

		/** @type {any} */
		this.tmp = {
			element: [],
		};

		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$routeParams = $routeParams;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.User = User;

		this.$scope.$on('$routeUpdate', (/** @type {any} */ event, /** @type {any} */ current) => {
			this.$timeout(async () => {
				if (current.params.tab && this.tab !== current.params.tab && current.params.tab !== 'undefined') {
					this.tab = current.params.tab;
				}
				if (current.params.kid && this.currentkid !== current.params.kid) {
					await this.init(current.params.kid);
				}
				if (!current.params.kid) {
					this.display = false;
					this.node = null;
				}
			});
		});
		if (this.$routeParams.kid) {
			(() => this.init(this.$routeParams.kid))();
		}
	}

	cancel() {
		if (this.node?.create) {
			this.node = null;
			this.display = false;
			this.tmp.element = [];
			this.$location.url('/admin/oo/');
		}
	}

	/**
	 * @param {any} object
	 */
	async createNode(object) {
		this.display = false;
		this.$rootScope.title = 'menu.admin-oo';
		this.$location.url('/admin/oo/');

		try {
			const result = await this.$uibModal.open({
				template:     templateModalAdminOoCreateClass,
				controller:   ModalAdminOoCreateClassController,
				controllerAs: '$ctrl',
				resolve:      {
					name: () => object.name,
					kid:  () => object.kid || `K_NODE;${this.User.getRef()}`,
				},
			}).result;

			this.node = this.NodeService.create('K_NODE;SYS_CLASSE', result.kid);
			this.node?.setName(result.name);
			this.currentkid = result.kid;
			this.display = true;
			this.oldNode = { ...this.node };
			this.$rootScope.title = `${this.node?.getName()} - ${this.$translate.instant('menu.admin-oo')}`;
			this.$location.url(`/admin/oo/${this.node?.kid}/info?create`);
			this.$timeout(() => {
				this.form?.$setDirty();
				this.tmp.element = [
					{
						kid:  this.node?.kid,
						name: this.node?.getName(),
					},
				];
			});
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
			this.display = false;
			this.node = null;
			this.oldNode = undefined;
		}
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @returns {Promise<any>}
	 */
	async init(kid) {
		this.$rootScope.title = 'menu.admin-oo';
		this.currentkid = kid;

		if ('create' in this.$location.search()) {
			if (!this.node) {
				await this.createNode({ kid });
			}
		}
		else {
			this.node = null;
			this.display = false;
			const node = await this.NodeService.loadAdmin(kid);

			if (node) {
				// Fix PHP json_encode {} => []
				// noinspection JSIncompatibleTypesComparison
				if (Array.isArray(node.kndef.CLASS.DICO) && node.kndef.CLASS.DICO.length === 0) {
					node.kndef.CLASS.DICO = {};
				}

				// Fix PHP json_encode {} => []
				// noinspection JSIncompatibleTypesComparison
				if (Array.isArray(node.kndefext.CLASS.DICO) && node.kndefext.CLASS.DICO.length === 0) {
					node.kndefext.CLASS.DICO = {};
				}

				this.display = true;
				this.node = node;
				this.oldNode = { ...node };
				this.$rootScope.title = `${node.getName()} - ${this.$translate.instant('menu.admin-oo')}`;
				this.$location.url(`/admin/oo/${node.kid}/${this.$routeParams.tab || 'info'}`);
				this.$timeout(() => {
					this.tmp.element = [
						{
							kid:  node.kid,
							name: node.getName(),
						},
					];
				});
			}
		}
	}

	nodeCreated() {
		this.Notification.success({
			title:   this.$translate.instant('object.successfully-created-title'),
			message: this.$translate.instant('object.successfully-created-message'),
		});
		this.$location.url(`/admin/oo/${this.node?.kid}/${this.$routeParams.tab || 'info'}`);
	}

	nodeDeleted() {
		this.Notification.success({
			title:   this.$translate.instant('object.successfully-deleted-title'),
			message: this.$translate.instant('object.successfully-deleted-message'),
		});
		this.display = false;
		this.tmp.element = [];
		this.$rootScope.title = 'menu.admin-oo';
		this.$location.url('/admin/oo/');
	}

	nodeUpdated() {
		this.Notification.success({
			title:   this.$translate.instant('object.successfully-updated-title'),
			message: this.$translate.instant('object.successfully-updated-message'),
		});
	}

	/**
	 * @param {any} item
	 */
	selectNode(item) {
		if (item) {
			this.$location.url(`/admin/oo/${item.kid}/${this.$routeParams.tab || 'info'}`);
		}
		else {
			this.$location.url('/admin/oo/');
		}
	}
}
